export const reviewKeys = {
  list: (locationId: string, responded?: boolean) =>
    responded === undefined
      ? (['reviews', 'list', locationId] as const)
      : (['reviews', 'list', locationId, responded] as const),
  stats: (locationId: string) => ['reviews', 'stats', locationId] as const,
  settings: (locationId: string) => ['reviews', 'settings', locationId] as const,
  reputation: (locationId: string) => ['reviews', 'reputation', locationId] as const,
  captureSummary: (locationId: string) => ['reviews', 'capture', 'summary', locationId] as const,
  captureFeedback: (locationId: string) => ['reviews', 'capture', 'feedback', locationId] as const,
  captureGoogle: (locationId: string) => ['reviews', 'capture', 'google', locationId] as const,
  captureBranding: (locationId: string) => ['reviews', 'capture', 'branding', locationId] as const,
  // Text review requests (PRD 5). Everything is location-scoped.
  smsProgram: (locationId: string) => ['reviews', 'sms', 'program', locationId] as const,
  /** Under the program's key, so every program change refreshes the heads-ups too. */
  smsHeadsUps: (locationId: string) =>
    ['reviews', 'sms', 'program', locationId, 'heads-ups'] as const,
  /** Every day of a location (prefix for invalidation). */
  smsDays: (locationId: string) => ['reviews', 'sms', 'day', locationId] as const,
  /** Every inbox filter of a location (prefix for invalidation). */
  smsInboxes: (locationId: string) => ['reviews', 'sms', 'inbox', locationId] as const,
  smsDay: (locationId: string, date: string | undefined) =>
    ['reviews', 'sms', 'day', locationId, date ?? 'today'] as const,
  smsInbox: (locationId: string, filter: string) =>
    ['reviews', 'sms', 'inbox', locationId, filter] as const,
  smsThread: (locationId: string, conversationId: string) =>
    ['reviews', 'sms', 'thread', locationId, conversationId] as const,
  /** Every range of a location's Performance / summary (prefixes for invalidation). */
  smsPerformances: (locationId: string) => ['reviews', 'sms', 'performance', locationId] as const,
  smsSummaries: (locationId: string) => ['reviews', 'sms', 'summary', locationId] as const,
  smsPerformance: (locationId: string, range: string) =>
    ['reviews', 'sms', 'performance', locationId, range] as const,
  smsSummary: (locationId: string, range: string) =>
    ['reviews', 'sms', 'summary', locationId, range] as const,
  smsOryx: (locationId: string) => ['reviews', 'sms', 'oryx', locationId] as const,
  smsRegistrationPrefill: (locationId: string) =>
    ['reviews', 'sms', 'registration-prefill', locationId] as const,
  smsEligibility: (locationId: string) => ['reviews', 'sms', 'eligibility', locationId] as const,
  smsAvailableNumbers: (
    locationId: string,
    areaCode: string,
    type: 'local' | 'toll_free' = 'local',
  ) => ['reviews', 'sms', 'numbers', locationId, type, areaCode] as const,
};
